import api from '@/libs/axios'

export default {
  async getAll() {
    let response = await api.get('/languages');
    return response
  },
  async create(payload) {
    const response = await api.post('/admin/languages', payload)
    return response
  },
  async update(payload) {
    let response = await api.put('/admin/languages', payload)
    return response
  },
  async delete(payload) {
    const response = await api.delete('/admin/languages', {
      data: payload,
    })
    return response
  },
  async getList(params) {
    let response = await api.get('/admin/languages', {
      params,
    })
    return response
  },
}
